import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=aca86520&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=aca86520&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca86520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aca86520')) {
      api.createRecord('aca86520', component.options)
    } else {
      api.reload('aca86520', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=aca86520&scoped=true&", function () {
      api.rerender('aca86520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4XoQQb9p6mYrj/JS/comp/Paginate.vue"
export default component.exports